import { takeLatest, put, call } from 'redux-saga/effects';

import { listPropriedadeCadastro } from '../service';
import {
  TABLE_PROPRIEDADE_CADASTRO,
  TABLE_PROPRIEDADE_CADASTRO_PENDING,
  TABLE_PROPRIEDADE_CADASTRO_SUCCESS,
  TABLE_PROPRIEDADE_CADASTRO_FAILURE,
} from '../actionTypes';

function* sagaListPropriedadeCadastro(action) {
  yield put({ type: TABLE_PROPRIEDADE_CADASTRO_PENDING });

  try {
    const table = yield call(listPropriedadeCadastro, action.args)
    yield put({ type: TABLE_PROPRIEDADE_CADASTRO_SUCCESS, table: table });

    if (action.resolve) {
      action.resolve();
    }
  } catch (error) {
    yield put({ type: TABLE_PROPRIEDADE_CADASTRO_FAILURE });

    if (action.resolve) {
      action.resolve();
    }
  }
}

export default function* watchListPropriedadeCadastro() {
  yield takeLatest(TABLE_PROPRIEDADE_CADASTRO, sagaListPropriedadeCadastro);
}
